import {Controller} from 'stimulus'

export default class extends Controller {
  static targets = [
    'title',
    // 'description',
    // 'link',
    'selected',
    'search',
    'blockPrices',
    'categoryPricesLink',
    'lastItem',
  ]

  connect() {
    this.priceList = document.getElementById('priceList')
    this.startObservingScrollPrice();
    this.startMutationObserver()
    this.setHeightLastItem()
  }

  setHeightLastItem() {
    const heightPrevEl = this.lastItemTarget.previousElementSibling.offsetHeight
    const height = 480 - heightPrevEl
    if (height > 20) {
      this.lastItemTarget.style.height = height + 'px'
    }
  }

  select(e) {
    e.preventDefault()
    if (this.searchTarget.value) {
      this.searchTarget.value = ''
      let url = document.getElementById('prices_search').action
      let prices = document.querySelector('#prices')
      fetch(`${url}?search=`, {
        method: 'GET',
        headers: {
          accept: "application/json"
        }
      })
          .then(response => response.json())
          .then(data => prices.innerHTML = data.prices)
          .then(d => this.startObservingScrollPrice())
          .then(d => this.scrollToElement(e.target.dataset.id))
    } else {
      this.scrollToElement(e.target.dataset.id)
    }
    this.resetActiveNavigationItems()
    this.setActiveNavigationItem(e.target)
  }

  scrollToElement(categoryId) {
    const h_price = document.getElementById(`categoryPriceId_${categoryId}`).offsetTop
    const contentWrapper = this.priceList.querySelector('.simplebar-content-wrapper')
    const h_contentWrapper = contentWrapper.offsetTop
    contentWrapper.scrollTo({
      top: h_price - h_contentWrapper,
      // behavior: 'smooth'
    })
  }

  resetActiveNavigationItems() {
    const activeNavigationItems = document.querySelectorAll('.navigation-categories-item.active')
    activeNavigationItems.forEach((item) => {
      item.classList.remove("active")
    });

    this.selectedTarget.textContent = 'Выберите категорию исследований'
    this.selectedTarget.classList.remove("active")
    this.titleTarget.textContent = `Категории исследований ${this.titleTarget.dataset.name}`
    // this.descriptionTarget.textContent = ''
    // this.linkTarget.href = this.linkTarget.dataset.link
  }

  setActiveNavigationItem(el) {
    el.classList.add("active");
    this.selectedTarget.textContent = el.dataset.name
    this.selectedTarget.classList.add("active")
    this.titleTarget.textContent = el.dataset.name
    // this.descriptionTarget.textContent = el.dataset.description
    // this.linkTarget.href = el.dataset.link
  }

  restartObservingScrollPrice() {
    // сброс активной категории
    this.resetActiveNavigationItems()
    // отключить IntersectionObserver
    this.stopObservingScrollPrice()
    // старт нового IntersectionObserver
    this.startObservingScrollPrice()
  }

  startMutationObserver() {
    this.mutationObserver = new MutationObserver(this.restartObservingScrollPrice.bind(this))
    // отслеживаем изменения содержания priceList после поиска
    this.mutationObserver.observe(this.priceList, {
      childList: true,
      subtree: true,
    });
  }

  startObservingScrollPrice() {
    this.intersectionObserver = new IntersectionObserver(this.updateScrollNavigation.bind(this), {
      root: this.priceList,
      rootMargin: '0px 0px -70% 0px',
      threshold: 0.1,
    });

    this.blockPricesTargets.forEach((el) => {
      this.intersectionObserver.observe(el);
    });
  }

  updateScrollNavigation(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.resetActiveNavigationItems()
        const activeItem = document.querySelector(`.navigation-categories-item[href="#${entry.target.id}"]`);
        this.setActiveNavigationItem(activeItem)
      }
    });
  };

  stopObservingScrollPrice() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  // disconnect() {
  //   this.stopObservingScrollPrice();
  // }
}
